__turbopack_context__.v({
  "buttonContainer": "XzgYRG_buttonContainer",
  "buttonContainersize_large": "XzgYRG_buttonContainersize_large",
  "buttonContainersize_medium": "XzgYRG_buttonContainersize_medium",
  "buttonContainersize_small": "XzgYRG_buttonContainersize_small",
  "root": "XzgYRG_root",
  "rootcolor_gray": "XzgYRG_rootcolor_gray",
  "rootcolor_primary": "XzgYRG_rootcolor_primary",
  "rootcolor_primary_isDisabled": "XzgYRG_rootcolor_primary_isDisabled",
  "rootcolor_sky": "XzgYRG_rootcolor_sky",
  "rootcolor_sky_isDisabled": "XzgYRG_rootcolor_sky_isDisabled",
  "rootisDisabled": "XzgYRG_rootisDisabled",
  "rootisDisabled_color_gray": "XzgYRG_rootisDisabled_color_gray",
  "rootnotInteractable": "XzgYRG_rootnotInteractable",
  "rootsize_large": "XzgYRG_rootsize_large",
  "rootsize_medium": "XzgYRG_rootsize_medium",
  "rootsize_small": "XzgYRG_rootsize_small",
  "slotTargetIcon": "XzgYRG_slotTargetIcon",
  "slotTargetIconcolor_gray": "XzgYRG_slotTargetIconcolor_gray",
  "slotTargetIconcolor_sky": "XzgYRG_slotTargetIconcolor_sky",
  "slotTargetIconcolor_sky_isDisabled": "XzgYRG_slotTargetIconcolor_sky_isDisabled",
  "slotTargetIconisDisabled": "XzgYRG_slotTargetIconisDisabled",
  "slotTargetIconisDisabled_color_gray": "XzgYRG_slotTargetIconisDisabled_color_gray",
  "svg__pHGrg": "XzgYRG_svg__pHGrg",
});
